import { render, staticRenderFns } from "./PaymentsForm.vue?vue&type=template&id=6dbb6140&"
import script from "./PaymentsForm.vue?vue&type=script&lang=js&"
export * from "./PaymentsForm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports